<template>
  <div class="label-box">
    <span class="eat-label" v-if="num==0">
      <img src="@/assets/images/item_icon_allow@2x.png" alt>
    </span>
    <span class="eat-label" v-else-if="num==1">
      <img src="@/assets/images/item_icon_ban@2x.png" alt>
    </span>
    <span class="eat-label" v-else-if="num==2">
      <img src="@/assets/images/item_icon_warning@2x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==3">
      <img src="@/assets/images/item_icon_4month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==4">
      <img src="@/assets/images/item_icon_6month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==5">
      <img src="@/assets/images/item_icon_8month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==6">
      <img src="@/assets/images/item_icon_10month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==7">
      <img src="@/assets/images/item_icon_12month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==8">
      <img src="@/assets/images/item_icon_18month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==9">
      <img src="@/assets/images/item_icon_24month@3x.png" alt>
    </span>
    <span class="eat-num-label" v-else-if="num==10">
      <img src="@/assets/images/item_icon_36month@3x.png" alt>
    </span>
  </div>
</template>
<script>
export default {
  name: "can-eat-label",
  props: ["num"]
};
</script>
<style lang="less">
.label-box {
  display: inline-block;
}
.eat-label {
  width: 12px;
  height: 14px;
  display: inline-block;
  vertical-align: sub;
  img {
    width: 100%;
    height: 100%;
  }
}
.eat-num-label {
  border-radius: 6px;
  color: #fff;
  display: inline-block;
  -webkit-text-size-adjust: none;
  height: 14px;
  width: 22px;
  vertical-align: sub;
}
.eat-num-label img {
  width: 100%;
  height: 100%;
}
.eat-num {
  font-size: 16px;
  transform: scale(0.5);
  display: inline-block;
  width: 36px;
  height: 20px;
  line-height: 20px;
  margin-left: -7px;
  margin-top: -12px;
  letter-spacing: 1px;
  text-align: center;
}
</style>

